import React from 'react';
import styles from './Field.less';

class Field extends React.Component {
	constructor() {
		super();
		this.state = {
			is_changed: false
		};
	}

	render() {
		const {label, children, className, ...props} = this.props;
		const {is_changed} = this.state;
		const {
			field: fieldClass,
			field__label: labelClass,
			field__box: boxClass
		} = styles;
		const classes = [fieldClass];

		if (className) {
			classes.push(className);
		}

		return (
			<div className={classes.join(' ')} {...props}>
				<div className={labelClass}>
					{label}
				</div>
				<div className={boxClass} onChange={e => this.setState({
					is_changed: true
				})}>{children}</div>
			</div>
		);
	}
}

export default Field;